// extracted by mini-css-extract-plugin
module.exports = {"classificationDisplay":"ClassificationDisplay_classificationDisplay__pmqLP","section":"ClassificationDisplay_section__LZC9L"};